import { cn } from '@/lib/utils';
import type { NoyauCode } from '@rosetta/shared';
import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { infobulleNoyauEnCours, nomNoyauEnCours } from './noyau-en-cours';

interface LienNoyauEnCoursProps {
  noyau: NoyauCode;
  /** The launch that translates the noyau: its waiting screen is where the link goes. */
  lancement: string;
  className?: string;
  /** What is drawn (the dot or the pill of the noyau, its code, the ring): decorative, the name is the link's own. */
  children: ReactNode;
}

/**
 * A noyau being translated by another launch of the document (#36), wherever the document lists
 * its noyaux (the tabs of the result, "Voir aussi" of the analysis, the card of the history): a
 * link to `/resultat/<launch>`, which shows the steps of that launch (W1). Its name is "<noyau>,
 * en cours de traduction", whatever is drawn inside.
 */
export function LienNoyauEnCours({ noyau, lancement, className, children }: LienNoyauEnCoursProps) {
  return (
    <Link
      to="/resultat/$id"
      params={{ id: lancement }}
      aria-label={nomNoyauEnCours(noyau)}
      title={infobulleNoyauEnCours(noyau)}
      className={cn('no-underline', className)}
    >
      {children}
    </Link>
  );
}
